import React from "react";
import { Navigate } from "react-router-dom";
import { getStoredAuthData, isEmbeddedMode } from "app/utils/auth";

interface GuestOnlyRouteProps {
  children: React.ReactElement;
}

export function GuestOnlyRoute({ children }: GuestOnlyRouteProps) {
  if (isEmbeddedMode()) {
    return <Navigate to="/" replace />;
  }

  if (getStoredAuthData()) {
    return <Navigate to="/" replace />;
  }

  return children;
}
